module.exports = __webpack_public_path__ + "media/music/2b7b80de8884cc3cf584aa0deb86a59b.mp3";